<template> 
  <div class="policies">
    <div class="table">
      <div class="table__header box box--default">
        <div class="table__label table__label--medium table__label--fixed">
          Status
        </div>
        <div class="table__label table__label--large">Policennummer</div>
        <div class="table__label table__label--large">Erstellungsdatum</div> 
        <div class="table__label table__label--large">Versicherer</div>
        <div class="table__label table__label--large">Branche</div>
        <div class="table__label table__label--medium">Zuständig</div>
        <div
          class="table__label table__label--medium table__label--more-horizontal table__label--last"
        ></div>
      </div>
      <Loading v-if="detailsLoading" />
      <div v-else class="table__body">
        <div v-if="!computedPendencies.length" class="table__no-data">
          <NoData :type="'pendencies'" />
        </div>
      
        <div v-else class="table__policies"> 
          <Pendency
            v-for="pendency in computedPendencies"
            :key="pendency.id"
            :statuses="statuses"
            :pendency="pendency"
            :expandedPendencyId = "expandedPendencyId"
          />
        </div>  
      </div>

      <!-- <Pagination
        :limit="3"
      :data="usersPerPage"
      @pagination-change-page="getResults"
    ></Pagination> -->
    </div>

    
  </div>

 
</template>

<script>
import Pendency from "@/components/AccountDetails/Pendency";
import Loading from "@/partials/Loading";
import NoData from "@/partials/NoData";
import { mapGetters } from "vuex";
export default {
  name: "PendenciesTable",

  components: {
    Pendency,
    Loading,
    NoData, 
  },

  computed: {
    ...mapGetters([
      "pendencyForms", "customerDetails"]
    ),
    computedPendencies() {
      return this.$store.getters.pendencies;
    },
    statuses() {
      return this.pendencyForms.statuses || [];
    },

    costumerId(){
      return this.$store.getters.customerDetailsId;
    }
  },

  async mounted(){
    // Only fetch if we haven't already fetched for this customer
    if (this.lastFetchedCustomerId === this.costumerId) { 
      return;
    }
     
    this.detailsLoading = true;
    try {
      if (this.customerDetails.team) { 
        this.teamId = Number(this.customerDetails.team.id);  
        await this.$store.dispatch("getPendencyForms", this.teamId);
      }
      await this.$store.dispatch("getPendencies", this.costumerId);
      this.lastFetchedCustomerId = this.costumerId; // Mark as fetched

    } catch (error) {
      console.log(error)
    } finally {
      this.detailsLoading = false;
    }
  },

  data(){
    return{
      detailsLoading: false,
      pendencies:[],
      lastFetchedCustomerId: null, // Track which customer data was fetched for
    }
  },

  props: {
    expandedPendencyId:{
      required: false,
      type: Number,
    }
  },
};
</script>
